import React from 'react';
import PropTypes from 'prop-types';
import {Button, Popover, Select} from 'antd';
import {DASHBOARD_PAGE, FAQ_PAGE, INDEX_PAGE, PROFILE_PAGE, WORKERS_PAGE} from '../../configuration/paths';
import {connect} from 'react-redux';
import {makeAction} from '../../redux/actions/makeAction';
import {LOG_OUT, OPEN_MODAL} from '../../redux/actions/actionTypes';
import {isLoggedIn} from '../../redux/selectors/auth';
import {Link} from 'react-router-dom';
import brand from '../../assets/img/brand.svg';
import brandMobile from '../../assets/img/brandMobile.svg';
import {withRouter} from 'react-router';
import TranslatedText from '../TranslatedText';
import {ReactComponent as Envelope} from '../../assets/img/envelope.svg';
import {useMediaQuery} from 'react-responsive';
import MobileDrawer from './MobileDrawer';
import MobileLocationIndicator from './MobileLocationIndicator';
import {useTranslation} from 'react-i18next';

const NavigationBar = ({loggedIn, logout, openModal, history, location}) => {
  const {i18n} = useTranslation();
  const isMobile = useMediaQuery({query: '(max-width: 1200px)'});
  return (
    <div className="container">
      <div className="brand-wrapper">
        <Link to={INDEX_PAGE}>
          <img alt="logo" src={isMobile ? brandMobile : brand} className="navigation-image"/>
        </Link>
      </div>
      {
        isMobile && <MobileLocationIndicator/>
      }
      {
        loggedIn
          ? <ul className="left-menu-wrapper">
            <li className={location.pathname === DASHBOARD_PAGE ? 'active' : ''}>
              <Link to={DASHBOARD_PAGE}>
                <TranslatedText transKey="navigation.pages.dashboard"/>
              </Link>
            </li>
            <li className={location.pathname === WORKERS_PAGE ? 'active' : ''}>
              <Link to={WORKERS_PAGE}>
                <TranslatedText transKey="navigation.pages.miners"/>
              </Link>
            </li>
            <li className={location.pathname === PROFILE_PAGE ? 'active' : ''}>
              <Link to={PROFILE_PAGE}>
                <TranslatedText transKey="navigation.pages.profile"/>
              </Link>
            </li>
          </ul>
          : <ul className="left-menu-wrapper">
            <li className={location.pathname === INDEX_PAGE ? 'active' : ''}>
              <Link to={INDEX_PAGE}>
                <TranslatedText transKey="navigation.pages.about"/>
              </Link>
            </li>
            <li className={location.pathname === FAQ_PAGE ? 'active' : ''}>
              <Link to={FAQ_PAGE}>
                <TranslatedText transKey="navigation.pages.faq"/>
              </Link>
            </li>
            <li>
              <Popover
                overlayClassName="contact-popover-wrapper"
                placement="bottom"
                content={
                  <div className="contact-popover">
                    <p className="contact-popover-title">
                      <Envelope/>
                      <span>
                      <TranslatedText transKey="navigation.contact.title"/>
                    </span>
                    </p>
                    <p className="contact-popover-content">
                      <a href="mailto:support@knoxpool.com" target="_blank" rel="noopener noreferrer">
                        <TranslatedText transKey="navigation.contact.mailLabel"/>
                      </a>
                    </p>
                  </div>
                }
                title={null}
                trigger="click"
              >
                <a>
                  <TranslatedText transKey="navigation.pages.contact"/>
                </a>
              </Popover>
            </li>
          </ul>
      }
      <ul className="right-menu-wrapper">
        {
          loggedIn
            ?
            <React.Fragment>
            <li className={location.pathname === INDEX_PAGE ? 'active' : ''}>
              <Link to={INDEX_PAGE}>
                <TranslatedText transKey="navigation.pages.about"/>
              </Link>
            </li>
            <li className={location.pathname === FAQ_PAGE ? 'active' : ''}>
              <Link to={FAQ_PAGE}>
                <TranslatedText transKey="navigation.pages.faq"/>
              </Link>
            </li>
            <li>
              <Button type="primary" size="large" onClick={() => {
                logout();
                history.push(INDEX_PAGE);
              }}>
                <TranslatedText transKey="navigation.actions.logout"/>
              </Button>
            </li>
            </React.Fragment>
            : <React.Fragment>
            </React.Fragment>
        }
        {
          location.pathname === INDEX_PAGE && !isMobile &&
            <li className="nav-language-select-menu-item">
              <Select dropdownClassName="nav-language-select-dropdown" className="nav-language-select" defaultValue="en" onChange={value => i18n.changeLanguage(value)}>
                <Select.Option value="en" className={i18n.language === 'en' ? 'active' : ''}>
                  <span className="language-text"><TranslatedText transKey="footer.language.englishAbbr"/></span>
                </Select.Option>
                <Select.Option value="zh" className={i18n.language === 'zh' ? 'active' : ''}>
                  <span className="language-text"><TranslatedText transKey="footer.language.chineseAbbr"/></span>
                </Select.Option>
                <Select.Option value="ko" className={i18n.language === 'ko' ? 'active' : ''}>
                  <span className="language-text"><TranslatedText transKey="footer.language.koreanAbbr"/></span>
                </Select.Option>
                <Select.Option value="ja" className={i18n.language === 'ja' ? 'active' : ''}>
                  <span className="language-text"><TranslatedText transKey="footer.language.japaneseAbbr"/></span>
                </Select.Option>
                <Select.Option value="es" className={i18n.language === 'es' ? 'active' : ''}>
                  <span className="language-text"><TranslatedText transKey="footer.language.spanishAbbr"/></span>
                </Select.Option>
                <Select.Option value="vi" className={i18n.language === 'vi' ? 'active' : ''}>
                  <span className="language-text"><TranslatedText transKey="footer.language.vietnameseAbbr"/></span>
                </Select.Option>
              </Select>
            </li>
        }
      </ul>
      <div className="mobile-drawer-wrapper">
        {
          isMobile && <MobileDrawer/>
        }
      </div>
    </div>
  );
};

NavigationBar.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  logout: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = state => ({
  loggedIn: isLoggedIn(state),
});

const mapDispatchToProps = {
  logout: makeAction(LOG_OUT),
  openModal: makeAction(OPEN_MODAL),
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(NavigationBar));



// WEBPACK FOOTER //
// /src/components/navigation/NavigationBar.jsx